import type { ModeDossier } from './types'

/**
 * Une couleur par type de dossier, pour qu'un coup d'œil suffise à savoir où
 * l'on est. Trois teintes seulement, assez sobres pour cohabiter avec le bleu
 * de l'application, et assez distinctes pour se reconnaître de loin.
 *
 * Les couleurs d'alerte (orange, rouge) ne sont jamais utilisées ici : elles
 * restent réservées à ce qui demande une attention.
 */
export const COULEURS_MODE: Record<
  ModeDossier,
  { accent: string; fond: string; texte: string }
> = {
  // Bleu : la teinte de base de l'application.
  GYNECOLOGIE_BENIGNE: { accent: '#2f7fe4', fond: '#eef5fe', texte: '#154f9c' },
  // Vert d'eau.
  OBSTETRIQUE: { accent: '#0d9488', fond: '#e8f8f5', texte: '#0f766e' },
  // Violet.
  ONCOLOGIE: { accent: '#7c3aed', fond: '#f4efff', texte: '#5b21b6' },
}

/** La pastille colorée qui nomme le type de dossier. */
export function styleMode(mode: ModeDossier) {
  const couleur = COULEURS_MODE[mode]
  return { backgroundColor: couleur.fond, color: couleur.texte }
}
